import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "project-display" }
const _hoisted_2 = {
  key: 0,
  class: "project-img"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["data-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.data.imgSrc.includes('</svg>'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.data.imgSrc,
            alt: _ctx.data.title
          }, null, 8, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "project-img",
          innerHTML: _ctx.data.imgSrc
        }, null, 8, _hoisted_4)),
    _createElementVNode("h3", {
      class: "project-title",
      "data-text": _ctx.data.title
    }, null, 8, _hoisted_5)
  ]))
}